import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import esgBoards, { esgBoardsSaga } from './esgBoards';
import esgFiles, { esgFilesSaga } from './esgFiles';

const esgModule = combineReducers({
  esgBoards,
  esgFiles,
});

export function* esgModuleSaga() {
  yield all([
    esgBoardsSaga(),
    esgFilesSaga(),
  ]);
}

export default esgModule;
